<div class="input-group {{ cssClass }}">
  <div
    [formGroup]="parentForm"
    class="input-label"
    [class.is-invalid]="isNotValidFunction ? isNotValidFunction : isNotValid(nameForm)"
    [ngClass]="hasValue() ? 'has-value' : ''">
    <input
      #d="ngbDatepicker"
      (change)="onChange($event)"
      (click)="disableDates(d); d.toggle()"
      (navigate)="navigate($event)"
      (ngModelChange)="onChange($event)"
      [dayTemplate]="customDayTemplate"
      [formControlName]="nameForm"
      [id]="idName"
      [firstDayOfWeek]="1"
      [showWeekNumbers]="true"
      [name]="nameForm"
      [outsideDays]="'collapsed'"
      [navigation]="navigation"
      [ngClass]="{ required: isRequired() }"
            [placeholder]="
                getFormattedDate() ? getFormattedDate() : placeholder ? placeholder : ('aimo.dateSelect' | cxTranslate)
            "
      [type]="typeInput ? typeInput : 'text'"
      [value]="getFormattedDate()"
      class="aimo-input form-control"
      name="dp"
      ngbDatepicker
      readonly />
  </div>
  <div class="input-group-prepend input-calendar-icon" (click)="disableDates(d); d.toggle()">
    <i class="aimo-icon icon-inline icon-sm icon-petrol-blue icon-calendar-blank"></i>
  </div>
</div>

@if ((isNotValidFunction ? isNotValidFunction : isNotValid(nameForm)) && errorMessage) {
  <div
    class="invalid-feedback d-block"
    >
    <span>{{ errorMessage | cxTranslate }}</span>
  </div>
}

@if (extraInfoBottom) {
  <div class="extra-info text-right">
    {{ extraInfoBottom | cxTranslate }}
  </div>
}
